import React from 'react';
import DashboardLayout from '../../components/dashboard/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Button } from '../../components/ui/button';
import { mockMessages } from '../../data/mock';
import {
  Mail,
  MailOpen,
  Calendar,
  AlertCircle,
  Info,
  CheckCircle2,
  Trash2,
  Archive
} from 'lucide-react';

const MensajesPage = () => {
  const getTypeIcon = (type) => {
    switch (type) {
      case 'warning': return <AlertCircle className="h-5 w-5 text-amber-600" />;
      case 'event': return <Calendar className="h-5 w-5 text-purple-600" />;
      case 'info': return <Info className="h-5 w-5 text-blue-600" />;
      default: return <Mail className="h-5 w-5 text-gray-600" />;
    }
  };

  const getTypeBadge = (type) => {
    switch (type) {
      case 'warning': return <Badge className="bg-amber-100 text-amber-700">Importante</Badge>;
      case 'event': return <Badge className="bg-purple-100 text-purple-700">Evento</Badge>;
      case 'info': return <Badge className="bg-blue-100 text-blue-700">Información</Badge>;
      default: return null;
    }
  };

  const unreadCount = mockMessages.filter(m => !m.read).length;

  return (
    <DashboardLayout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">Bandeja de Mensajes</h2>
            <p className="text-gray-600">
              {unreadCount > 0 
                ? `Tienes ${unreadCount} mensaje${unreadCount > 1 ? 's' : ''} sin leer`
                : 'Todos los mensajes leídos'
              }
            </p>
          </div>
          <div className="flex items-center space-x-2">
            <Button variant="outline" size="sm">
              <Archive className="h-4 w-4 mr-2" />
              Archivar leídos
            </Button>
          </div>
        </div>

        {/* Messages List */}
        <div className="space-y-4">
          {mockMessages.map((message) => (
            <Card 
              key={message.id} 
              className={`transition-all hover:shadow-md cursor-pointer ${
                !message.read ? 'border-l-4 border-l-emerald-600' : ''
              }`}
            >
              <CardContent className="p-6">
                <div className="flex items-start space-x-4">
                  <div className={`h-12 w-12 rounded-full flex items-center justify-center flex-shrink-0 ${
                    !message.read ? 'bg-emerald-100' : 'bg-gray-100'
                  }`}>
                    {!message.read 
                      ? <Mail className="h-6 w-6 text-emerald-600" />
                      : <MailOpen className="h-6 w-6 text-gray-400" />
                    }
                  </div>
                  
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between">
                      <div>
                        <div className="flex items-center space-x-2 mb-1">
                          <h3 className={`font-semibold ${
                            !message.read ? 'text-gray-900' : 'text-gray-700'
                          }`}>
                            {message.title}
                          </h3>
                          {!message.read && (
                            <Badge className="bg-emerald-600 text-white text-xs">Nuevo</Badge>
                          )}
                        </div>
                        <div className="flex items-center space-x-2">
                          {getTypeBadge(message.type)}
                          <span className="text-sm text-gray-500">
                            {new Date(message.date).toLocaleDateString('es-MX', {
                              day: 'numeric',
                              month: 'long',
                              year: 'numeric'
                            })}
                          </span>
                        </div>
                      </div>
                      <div className="flex items-center space-x-1 ml-4">
                        {getTypeIcon(message.type)}
                      </div>
                    </div>
                    
                    <p className="text-gray-600 mt-3">{message.content}</p>
                    
                    <div className="flex items-center space-x-3 mt-4">
                      <Button size="sm" variant="outline">
                        {message.read ? 'Marcar como no leído' : 'Marcar como leído'}
                      </Button>
                      <Button size="sm" variant="ghost" className="text-red-600 hover:text-red-700 hover:bg-red-50">
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {mockMessages.length === 0 && (
          <Card>
            <CardContent className="p-12 text-center">
              <Mail className="h-12 w-12 text-gray-300 mx-auto mb-4" />
              <p className="text-gray-500">No tienes mensajes</p>
            </CardContent>
          </Card>
        )}
      </div>
    </DashboardLayout>
  );
};

export default MensajesPage;
